// 19.1.3.1 Object.assign(target, source)
var $export = require('./$.export');

$export($export.S + $export.F, 'Object', {assign: require('./$.object-assign')});


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/core-js/library/modules/es6.object.assign.js
 ** module id = 1135
 ** module chunks = 0
 **/